var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasPageMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 226,
    viewBox: "0 0 178 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_726_4880)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 160,
    height: 208,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 6.5,
    width: 159,
    height: 207,
    rx: 5.5,
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 11V10.9979C168.495 9.69855 167.774 8.56446 166.695 7.77225C165.616 6.97982 164.15 6.50364 162.553 6.5H162.552L15.4483 6.5L15.4471 6.5C13.8498 6.50364 12.3843 6.97982 11.3049 7.77225C10.2259 8.56447 9.50549 9.69856 9.5 10.9979H9.5V11V23V23.5H10H168H168.5V23V11Z",
    fill: "#E5E8F5",
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.2402H24V18.4802H18V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12.2402H34V18.4802H28V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 12.2402H44V18.4802H38V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 12.2402H113V18.4802H58V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5252 92.8813H52.6764C54.1366 92.8813 55.3203 94.065 55.3203 95.5252V129.896C55.3203 131.356 54.1366 132.54 52.6764 132.54H31.5252C30.065 132.54 28.8813 131.356 28.8813 129.896V95.5252C28.8813 94.065 30.065 92.8813 31.5252 92.8813Z",
    stroke: "#4C6FFF",
    strokeWidth: 1.7626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 127,
    width: 15,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 123,
    width: 19,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7269 92.8813H83.8781C85.3383 92.8813 86.522 94.065 86.522 95.5252V129.896C86.522 131.356 85.3383 132.54 83.8781 132.54H62.7269C61.2667 132.54 60.083 131.356 60.083 129.896V95.5252C60.083 94.065 61.2667 92.8813 62.7269 92.8813Z",
    stroke: "#4C6FFF",
    strokeWidth: 1.7626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.2017,
    y: 127,
    width: 15,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.2017,
    y: 123,
    width: 19,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9284 92.8813H115.08C116.54 92.8813 117.724 94.065 117.724 95.5252V129.896C117.724 131.356 116.54 132.54 115.08 132.54H93.9284C92.4682 132.54 91.2845 131.356 91.2845 129.896V95.5252C91.2845 94.065 92.4682 92.8813 93.9284 92.8813Z",
    stroke: "#4C6FFF",
    strokeWidth: 1.7626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.4032,
    y: 127,
    width: 15,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.4032,
    y: 123,
    width: 19,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.13 92.8813H146.281C147.741 92.8813 148.925 94.065 148.925 95.5252V129.896C148.925 131.356 147.741 132.54 146.281 132.54H125.13C123.67 132.54 122.486 131.356 122.486 129.896V95.5252C122.486 94.065 123.67 92.8813 125.13 92.8813Z",
    stroke: "#4C6FFF",
    strokeWidth: 1.7626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.605,
    y: 127,
    width: 15,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.605,
    y: 123,
    width: 19,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5252 135.881H52.6764C54.1366 135.881 55.3203 137.065 55.3203 138.525V172.896C55.3203 174.356 54.1366 175.54 52.6764 175.54H31.5252C30.065 175.54 28.8813 174.356 28.8813 172.896V138.525C28.8813 137.065 30.065 135.881 31.5252 135.881Z",
    stroke: "#4C6FFF",
    strokeWidth: 1.7626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 170,
    width: 15,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 166,
    width: 19,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7269 135.881H83.8781C85.3383 135.881 86.522 137.065 86.522 138.525V172.896C86.522 174.356 85.3383 175.54 83.8781 175.54H62.7269C61.2667 175.54 60.083 174.356 60.083 172.896V138.525C60.083 137.065 61.2667 135.881 62.7269 135.881Z",
    stroke: "#4C6FFF",
    strokeWidth: 1.7626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.2017,
    y: 170,
    width: 15,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.2017,
    y: 166,
    width: 19,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9284 135.881H115.08C116.54 135.881 117.724 137.065 117.724 138.525V172.896C117.724 174.356 116.54 175.54 115.08 175.54H93.9284C92.4682 175.54 91.2845 174.356 91.2845 172.896V138.525C91.2845 137.065 92.4682 135.881 93.9284 135.881Z",
    stroke: "#4C6FFF",
    strokeWidth: 1.7626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.4032,
    y: 170,
    width: 15,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.4032,
    y: 166,
    width: 19,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.13 135.881H146.281C147.741 135.881 148.925 137.065 148.925 138.525V172.896C148.925 174.356 147.741 175.54 146.281 175.54H125.13C123.67 175.54 122.486 174.356 122.486 172.896V138.525C122.486 137.065 123.67 135.881 125.13 135.881Z",
    stroke: "#4C6FFF",
    strokeWidth: 1.7626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.605,
    y: 170,
    width: 15,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.605,
    y: 166,
    width: 19,
    height: 2,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 182,
    width: 122,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 109L156 113L153 116.5",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 109L22 113L25 116.5",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 152L22 156L25 159.5",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 152L156 156L153 159.5",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 42,
    width: 120,
    height: 48,
    rx: 4,
    fill: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 38,
    width: 120,
    height: 48,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 62.4L82 72.8V52L95 62.4Z",
    fill: "white",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_726_4880",
    x: 0,
    y: 0,
    width: 178,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_726_4880"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_726_4880"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_726_4880",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPageMembers);
export default __webpack_public_path__ + "static/media/canvas_page_members.887d18c6c1066ce623f527686c2bc1d2.svg";
export { ForwardRef as ReactComponent };